import React, { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";

export default function PublicNews() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/updates?tenant_slug=abrah").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-display text-3xl font-bold text-gray-900 mb-2">News & Updates</h1>
      <p className="text-sm text-gray-600 mb-8">Promotions, store news and announcements from Abrah Supermarket.</p>
      {items.length === 0 ? (
        <div className="bg-white border border-dashed border-gray-300 rounded-md p-10 text-center text-sm text-gray-600">
          No posts published yet. Check back soon.
        </div>
      ) : (
        <div className="space-y-4" data-testid="news-list">
          {items.map((u) => (
            <article key={u.id} className="bg-white border border-gray-200 rounded-md overflow-hidden">
              {u.image_file_id && <img src={fileUrl(u.image_file_id)} alt={u.title} className="w-full h-56 object-cover" />}
              <div className="p-5">
                <div className="text-[10px] uppercase tracking-widest text-amber-700 mb-1">
                  {u.category || "news"} · {new Date(u.created_at).toLocaleDateString()}
                </div>
                <h2 className="font-display text-xl font-bold text-gray-900">{u.title}</h2>
                <p className="text-sm text-gray-700 mt-2 whitespace-pre-wrap">{u.body}</p>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
